import PropTypes from 'prop-types';
import React from 'react';
import { FEEDBACK_TAB_ARIA_LABEL, FEEDBACK_TAB_LABEL } from './feedbackCopy';
export const TAB_BASE_CLASS = 't-feedback-tab';
export const TAB_OPEN_CLASS = 't-feedback-tab--open';
const FeedbackTab = ({
  isPanelOpen,
  onOpen
}) => /*#__PURE__*/React.createElement("button", {
  type: "button",
  className: `${TAB_BASE_CLASS}${isPanelOpen ? ` ${TAB_OPEN_CLASS}` : ''}`,
  "aria-label": FEEDBACK_TAB_ARIA_LABEL,
  "aria-expanded": isPanelOpen,
  "aria-haspopup": "dialog",
  onClick: onOpen
}, /*#__PURE__*/React.createElement("span", {
  className: "t-feedback-tab__label"
}, FEEDBACK_TAB_LABEL));
FeedbackTab.propTypes = {
  isPanelOpen: PropTypes.bool.isRequired,
  onOpen: PropTypes.func.isRequired
};
export default FeedbackTab;